import { useContext } from 'react';
import { ToastContext, type ToastContextType } from '@/contexts/toastContextDef';

/**
 * Хук для использования Toast уведомлений
 */
export const useToastContext = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within ToastProvider');
  }
  return context;
};

